import { render, staticRenderFns } from "./mobileStep4AndroidOld.vue?vue&type=template&id=22aa9eb1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./mobileStep4AndroidOld.vue?vue&type=custom&index=0&blockType=scrtipt"
if (typeof block0 === 'function') block0(component)

export default component.exports